import React from 'react'
import Home from './components/pages/Home'

const App = () => <Home />

export default App
